import { MeasurementName } from '@quromedical/models';
import { compact } from '@quromedical/utils';

import type { Configuration, Resolver } from './internal';
import { interpret } from './interpreter';

export type GlucoseParams = {};

const referenceMeasures = [
  MeasurementName.GlucoseBeforeMeal,
  MeasurementName.GlucoseAfterMeal,
  MeasurementName.GlucoseFasting,
];

const resolveGlucose: Resolver<GlucoseParams> = (_, windowVitals) => {
  const values = referenceMeasures.map((type) => windowVitals[type]);

  return compact(values).map((value) => ({
    ...value,
    type: MeasurementName.Glucose,
  }));
};

const configurations = referenceMeasures.map<Configuration<GlucoseParams>>(
  (base) => ({
    base,
    resolve: resolveGlucose,
  }),
);

export const calculateGlucose = interpret(configurations);
